import { useNavigate } from "react-router-dom";
import { ModalComponent } from "../..";
import { useModalControl } from "../../../../customHooks/useModalControl";
import { SingleCooperativeDetails } from "../../../../redux/features/cooperative/cooperative.type";
import { InformationCard } from "../../../cards/infoCard";
import { SuccessModal } from "../successModal";
import { ChooseDebitInstrumentModal } from "./chooseDebitInstrument";

export const EnforceDirectDebitSetupModal = ({
  isModalOpen,
  cooperativeDetails,
  type,
  onClose,
  onSuccess,
}: {
  isModalOpen: boolean;
  cooperativeDetails: SingleCooperativeDetails;
  type: "new" | "change";
  onClose?: () => void;
  onSuccess?: () => void;
}) => {
  const navigate = useNavigate();

  const { modal, modalOpen, handleModalClose, handleModalOpen } =
    useModalControl();

  return (
    <>
      <ModalComponent
        isModalOpen={isModalOpen && !modalOpen}
        onModalClose={() => {}}
        title="Enable Direct Debit to Continue"
        showHeader={false}
        showMobileTopBar={false}
        modalClassName="!min-h-fit"
        childrenClassName="text-sm text-pry-dark-green-300/80"
        hasButtons
        hasCancelButton
        proceedButtonText="Authorize Direct Debit"
        cancelButtonText={type === "change" ? "Cancel" : "Maybe Later"}
        proceedButtonVariant="primary"
        cancelButtonVariant="secondary"
        onProceedClick={() => {
          handleModalOpen("chooseDebitInstrumentModal");
        }}
        onCancelClick={() => {
          if (type === "new") {
            navigate("/app/my-cooperatives");
          } else {
            onClose?.();
          }
        }}
        isLoading={false}
        isProceedDisabled={false}
        closeOnOutsideClick={false}
      >
        <InformationCard
          info={
            "This cooperative uses direct debit for member contributions. To access the cooperative page, please authorize direct debit by linking your bank account or card."
          }
          innerClassName="text-info-purple"
          size="mini"
          variant="purple"
        />

        <ul className="list-outside list-disc pl-5 mt-2">
          <li className="">
            Your account will only be debited when contributions are due.
          </li>
          {/* <li>You can disable direct debit anytime in your settings.</li> */}
        </ul>

        <hr className="mt-6 mb-4" />

        <p>
          By continuing, you agree to authorize direct debit for{" "}
          <span className="font-medium text-pry-green-200">
            {cooperativeDetails.CoopName}
          </span>
        </p>
      </ModalComponent>

      <ChooseDebitInstrumentModal
        isModalOpen={modalOpen && modal === "chooseDebitInstrumentModal"}
        cooperativeDetails={cooperativeDetails}
        type={["bank", "card"]}
        handleModalClose={() => {
          handleModalClose();
        }}
        onSuccess={() => {
          handleModalOpen("successModal");
          onSuccess?.();
        }}
      />

      <SuccessModal
        isModalOpen={modalOpen && modal === "successModal"}
        onModalClose={() => {
          handleModalClose();
          onClose?.();
        }}
        message="You’ve successfully activated direct debit for this cooperative"
      />
    </>
  );
};
